import { Fragment } from 'react';

import { Collapse } from 'react-bootstrap';

import { Accordion } from 'components/Accordion/Accordion';
import { Input, InputGroup, Select, ToggleLabel } from 'components/FormComponents';

const settingsHeader = <span className="text-neutral-7 text-xl font-medium">Settings</span>;

export const OpinionScaleSettings = ({ register, name, field, watch }) => (
  <Fragment>
    <div className="flex flex-col overflow-hidden u-margin-top">
      <Accordion defaultCollapsed={false} header={settingsHeader}>
        <div className="border border-neutral-4 rounded-2xl overflow-hidden">
          <div className="px-4 py-2 border-b border-neutral-4">
            <ToggleLabel register={register} name={`${name}.required`} label="Required" />
          </div>
          <Fragment>
            <div className="px-4 py-2 border-b border-neutral-4">
              <ToggleLabel
                register={register}
                name={`${name}.use_description`}
                label="Add description"
              />
              <Collapse in={field.use_description}>
                <div>
                  <Input
                    register={register}
                    name={`${name}.description`}
                    className="u-margin-top--small u-margin-bottom"
                    placeholder="Enter description..."
                  />
                </div>
              </Collapse>
            </div>
          </Fragment>
          <Fragment>
            <div className="px-4 py-2">
              <ToggleLabel
                register={register}
                name={`${name}.options.use_custom_steps`}
                label="Customise steps"
              />
              <Collapse in={field.options?.use_custom_steps}>
                <div>
                  <div className="d-flex align-items-center">
                    <Select
                      register={register}
                      name={`${name}.options.steps_start`}
                      value={watch(`${name}.options.steps_start`)}
                      className="u-margin-right"
                      useDefault>
                      <Select.Item value="0">0</Select.Item>
                      <Select.Item value="1">1</Select.Item>
                    </Select>
                    <p className="u-margin-0 t-body">to</p>
                    <Select
                      register={register}
                      name={`${name}.options.steps_end`}
                      value={watch(`${name}.options.steps_end`)}
                      className="u-margin-left"
                      useDefault>
                      <Select.Item value="3">3</Select.Item>
                      <Select.Item value="5">5</Select.Item>
                      <Select.Item value="7">7</Select.Item>
                      <Select.Item value="10">10</Select.Item>
                    </Select>
                  </div>
                  <div className="d-flex align-items-center u-margin-top">
                    <InputGroup
                      title={`"${field.options?.steps_start}" Label`}
                      className="u-margin-right--large u-margin-bottom--0">
                      <Input
                        name={`${name}.options.label_start`}
                        placeholder="Enter label"
                        register={register}
                      />
                    </InputGroup>
                    <InputGroup
                      title={`"${field.options?.steps_end}" Label`}
                      className="u-margin-left u-margin-bottom--small">
                      <Input
                        name={`${name}.options.label_end`}
                        placeholder="Enter label"
                        register={register}
                      />
                    </InputGroup>
                  </div>
                </div>
              </Collapse>
            </div>
          </Fragment>
        </div>
      </Accordion>
    </div>
  </Fragment>
);
